import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import TablePagination from '@material-ui/core/TablePagination';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { connect } from "react-redux";
import MainWrapper from "../wrappers/MainWrapper";
import CircularProgress from '@material-ui/core/CircularProgress';
import { Link } from "react-router-dom";
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import CustomTextField from "../../components/fields/CustomTextField";
import CheckboxGroup from "../../components/fields/CheckboxGroup";
import { reduxForm, Field, reset } from "redux-form";
import validateEmail from "../../utils/validateEmail";
import {   fetchAllEmail,editEmail ,checkUserRole} from "../../actions";
import Snackbar from '@material-ui/core/Snackbar';
import NotificationSnackBar from '../../utils/NotificationSnackBar';
import PlusCircleIcon from '@material-ui/icons/AddCircle';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import SearchIcon from '@material-ui/icons/Search';
import EnhancedTableToolbar from '../../utils/EnhancedTableToolbar';
import UserTable from '../../utils/MainTable/UserTable';
import { userListStyle } from '../../utils/Style';
import EmailTable from '../../utils/MainTable/EmailTable';

function getModalStyle() {
    return {
        top: `${50}%`,
        left: `${50}%`,
        transform: `translate(-${50}%, -${50}%)`,
    };
}


const WAIT_INTERVAL = 1000;

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    loadingHeight: {
        height: "100%",
        position: "fixed",
        top: "0",
        right: "0"
    },
    container: {
        display: "flex",
        flexWrap: "wrap",
        width: 350
    },
    button: {
        width: 300,
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: 10
    },
    alreadySignIn: {
        marginTop: 10,
        marginBottom: 10,
        marginLeft: "auto",
        marginRight: "auto"
    },
    success: {
        marginTop: 10,
        marginBottom: 10,
        marginLeft: "auto",
        marginRight: "auto",
        color: "green"
    }
});

class EmailList extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            open: false,
            userRoles:{
                userRoles:[],
                error:null
            },
            isSwitchSnackbarOn: false,
            loading:false, 
            emailContent:'',
            result:[],
            emailViewEdit:null,
        }; 
        this.props.checkUserRole();
    }
 
    componentDidMount(){ 
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();

        today =yyyy + '-' +mm + '-' + dd ;
        this.setState({ loading: false,
            dateFrom: today,
            dateTo:today,
            result:[],
        }); 
    }
 
    handleUpdateEmailStatus=()=>{   
        this.setState({ loading: true});
        var updated = this.state.updatedData;
        console.log(updated);
        this.props.editEmail(updated);
    }

    handleChange=(name)=>(event )=>{
        this.updateSnackbarStatusFalse();
        this.setState({[name]: event.target.value});
    }

    
    static getDerivedStateFromProps(props, state) {
        let update = {};
        if (props.result  !== state.result) {
            update.result =props.result;
            update.loading= false ;
        }

        if(props.emailViewEdit !== state.emailViewEdit){
            console.log(props.emailViewEdit);
            update.emailViewEdit = props.emailViewEdit;
            update.loading=false;
            update.isSnackbarError = props.emailViewEdit.isSnackbarError;
            update.isSwitchSnackbarOn =props.emailViewEdit.isSwitchSnackbarOn;
            update.snackbarErrorMessage =props.emailViewEdit.ErrorMessage;
        }
          
        if(props.userRoles.success !== null)
        if(!props.userRoles.success){ 
            localStorage.clear(); 
            props.history.push("/signIn"); 
        }
        if(props.userRoles.userRoles.length !== state.userRoles.userRoles.length){ 
            if(props.userRoles.userRoles.length === 0){ 
            localStorage.clear(); 
            props.history.push("/signIn"); 
            }
        }

        return update; 
    }

    updateSnackbarStatus = (snackbarObject) => {
        this.setState({
            isSnackbarError: snackbarObject.isSnackbarError,
            isSwitchSnackbarOn: snackbarObject.isSwitchSnackbarOn,
            snackbarErrorMessage: snackbarObject.ErrorMessage
        })
    }

    updateSnackbarStatusFalse = () => {
        if (this.state.isSwitchSnackbarOn) {
            this.setState({ isSwitchSnackbarOn: false })
        }
    }
    
    
    handleSearch = event => {  
        this.setState({ loading: true, });  
        this.updateSnackbarStatusFalse();   
       // this.setState({ searchVal: event.target.value })
       this.props.fetchAllEmail(this.state.emailContent); 
    };


    
    handleEditedContent=(data)=>{
        console.log(data)
        this.setState({updatedData: data});
    }


    render() {

        const { classes } = this.props;
        const { users, order, orderBy, selected, rowsPerPage, page, offset, isSwitchSnackbarOn, isSnackbarError } = this.state;
      
        return (
            <MainWrapper
                history={this.props.history}
                isDisplayOn="none"
                userRoles={this.props.userRoles}>
          

                <Paper className={classes.root}>
                    <EnhancedTableToolbar
                        tableName='Search Email' 
                        numSelected={0}
                    />
                    <div className={classes.search} style={{padding:'10px', paddingLeft:'20px'}}>
                        <Grid container spacing={8} alignItems="flex-end">
                            <Grid item>
                                <SearchIcon />
                            </Grid>
                            <Grid item>
                            <TextField
                                id="contentEmail"
                                label="Email Content"
                                defaultValue={this.state.emailContent}
                                InputLabelProps={{
                                shrink: true,
                                }} 
                                onChange={this.handleChange('emailContent')}
                            />
                            </Grid>
                            <Grid item>
                                <Button  variant="outlined"
                                onClick={(e) => this.handleSearch(e) } >Search</Button>
                            </Grid>
                            
                        </Grid>
                    </div>
                    <div className={classes.tableWrapper}>
                    <Grid container >
                            <Grid item xs={12}>
                                <EmailTable 
                                    data={this.state.emailViewEdit.results} 
                                    handleEditedContent={this.handleEditedContent}
                                />
                            </Grid> 
                            <Grid item xs={12}>
                                <Grid container justify='center' alignItems='center'>
                                    <Button
                                            className={classes.button}
                                            type="submit"
                                            variant="contained"
                                            color="primary"
                                            disabled={this.state.isSwitchSnackbarOn}
                                            onClick={this.handleUpdateCompanyInfo}
                                        >
                                            Save Edited info
                                        </Button> 
                                   
                                </Grid>
                        
                            </Grid>
                        </Grid>
                    </div>
                    <NotificationSnackBar
                            isSwitchSnackbarOn={this.state.isSwitchSnackbarOn}
                            isSnackbarError={this.state.isSnackbarError}
                            snackbarErrorMessage={this.state.snackbarErrorMessage}
                    />
                </Paper> 
                {this.state.loading ? (
                <Grid container className={classes.root}>
                    <Grid item xs={12}>
                        <Grid container className={classes.loadingHeight} justify='center' alignItems='center'>
                        <div className="d-flex justify-content-center">
                            <CircularProgress color="primary" size={70} thickness={7} />
                            </div>
                        </Grid>
                    </Grid>
                </Grid>
            ) : null
            }
            </MainWrapper>
        );
    }
}

EmailList.propTypes = {
    classes: PropTypes.object.isRequired,
};

function validate(values) {
    const errors = {};

    
    return errors;
}

let SignInWithStyles = withStyles(styles)(EmailList);

SignInWithStyles = reduxForm({ 
    form: "EmailListForm"
})(SignInWithStyles);

const mapStateToProps = ({ emailViewEdit,userRoles }) => { 
    return { 
        emailViewEdit:emailViewEdit,
        userRoles: userRoles, 
    };
};

export default connect(
    mapStateToProps,
    {  checkUserRole, fetchAllEmail,editEmail }
    
)(SignInWithStyles);




// WEBPACK FOOTER //
// ./src/components/tabs/EmailList.js